export default __webpack_public_path__ + "static/media/redtapeCover.c28db070.jpeg";